import { NotEmptyString } from '../Shared'

export class ActivityCode extends NotEmptyString {
  code (): string {
    return this.value()
  }
}
